import PropTypes from 'prop-types'
import React from 'react'
import { ThemeContext } from 'styled-components'

import HowToBlock from 'components/_special/HowToBlock'
import RenderInView from 'components/RenderInView'
import { Text } from 'styles/components/typography'

import burgerBan from './assets/burger-ban.svg'
import {
  TubeWrapper,
  EatIcon,
  SectionWrapperStyled,
  DynamicImageStyled,
} from './styles'

/**
 * DHowSpit
 *
 * @param {object} props - properties of component
 * @returns {node} DHowSpit
 */
const WHowSpit = ({ data, index, isSquareHidden, pathCdn }) => {
  const { colors } = React.useContext(ThemeContext)
  const imgPath = `${pathCdn}/spit/tube`

  return (
    <SectionWrapperStyled isOverflowHidden={true}>
      <HowToBlock
        isSquareHidden={isSquareHidden}
        title={data.title}
        index={index}
        squareColor={colors.cerulean}
        lineColor="light"
        textColor="light"
      >
        <div className="row">
          <div className="col-12 col-md-5 col-lg-5 offset-md-1 pb-2 pb-md-4 pb-lg-0">
            <div className="mb-2">
              <Text
                className="text--white with-inverted-links"
                dangerouslySetInnerHTML={{ __html: data.content_start }}
              />
            </div>
            <EatIcon alt="" className="mb-2" src={burgerBan} />
            <Text
              className="text--white with-inverted-links"
              dangerouslySetInnerHTML={{ __html: data.content_end }}
            />
          </div>
          <div className="col-12 col-md-6">
            <TubeWrapper>
              <RenderInView>
                <DynamicImageStyled
                  alt="wgs-tube-spit"
                  image={imgPath}
                  imageSizes={{ xs: 300, md: 350 }}
                  imageType="png"
                  fitOption="contain"
                />
              </RenderInView>
            </TubeWrapper>
          </div>
        </div>
      </HowToBlock>
    </SectionWrapperStyled>
  )
}

WHowSpit.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  pathCdn: PropTypes.string.isRequired,
  isSquareHidden: PropTypes.bool,
}

WHowSpit.defaultProps = {
  isSquareHidden: false,
}

export default WHowSpit
